<template>
    <div class="gallery-lightbox" @click.self="$emit('onClose')">
        <button class="btn-close" @click="$emit('onClose')">
            <svgComponent
                :width="48"
                :height="48"
                class-name="icon"
                icon-name="icon-cross"></svgComponent>
        </button>
        <div class="gallery-lightbox__container">
            <Swiper :slides-per-view="1" :space-between="10" navigation :modules="[Navigation]">
                <swiper-slide v-for="(item, index) in slides" :key="`lightbox-${index}`">
                    <img
                        :class="{ 'is-current': index === activeIndex }"
                        :src="item.ImageUrl"
                        :alt="item.AlternativeText" />
                </swiper-slide>
            </Swiper>
        </div>
    </div>
</template>

<script setup lang="ts">
// Components
import svgComponent from '../../../components/svgComponent.vue';

// Vendor
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper';

// Model
import { IGalleryItem } from '../model';
defineProps<{
    slides: IGalleryItem[];
    activeIndex: number;
}>();
</script>
